import { render, staticRenderFns } from "./SendDraftsDialog.vue?vue&type=template&id=4031406d&scoped=true"
import script from "./SendDraftsDialog.vue?vue&type=script&lang=js"
export * from "./SendDraftsDialog.vue?vue&type=script&lang=js"
import style0 from "./SendDraftsDialog.vue?vue&type=style&index=0&id=4031406d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4031406d",
  null
  
)

export default component.exports